import DeliveryImage from '@/assets/images/delivery-image.png';
import AddressMainTitle from "./AddressMainTitle";
import AddressIllustration from './AddressIllustration';

const AddressSideComponent: React.FC = () => {
    return (
        <div>
            <div className="top-img-container w-full flex flex-row justify-center items-center desktop-min:hidden">
                <img src={DeliveryImage} alt="About you image" className="delivery h-auto block w-[6.5rem]" />
            </div>
            <AddressMainTitle />
            <div className="hidden desktop-min:block md-min:mr-[2rem] md-min:pl-[2rem]">
                <AddressIllustration />
            </div>
        </div>
    );
};

export default AddressSideComponent;